import React from 'react';

const BookCover = ({ className = '', size = 'md' }) => {
  const sizeClasses = {
    sm: 'max-w-xs',
    md: 'max-w-md',
    lg: 'max-w-lg',
  };

  return (
    <div className={`relative ${sizeClasses[size]} ${className}`}>
      <div className="absolute inset-0 bg-brand-accent/25 blur-3xl rounded-full transform -translate-y-8 scale-110 pointer-events-none" />
      <div className="relative shadow-2xl shadow-slate-900/50 rounded-r-2xl rounded-l-sm overflow-hidden border-l-4 border-slate-300/40 transform transition-transform duration-700 hover:-translate-y-2 hover:rotate-1">
        <img
          src="https://media-manager-c.questera.ai/greta-media/ae05bbc051fb17176d2c348bf77438a7a494626431a725f22ebe70ac4579d949c16512ea83019a888cf26e0e50680ce7/images/aW1hZ2UvanBlZw==/20e3fa32d07bba78da9541e9697e8f80.jpg"
          alt="How to Love a Good Man - Book Cover by Andrei Ciomîrtan"
          className="w-full h-auto object-cover aspect-[2/3]"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
        {/* Fallback styled cover */}
        <div style={{ display: 'none' }} className="aspect-[2/3] bg-gradient-to-b from-slate-800 to-slate-900 p-8 flex-col justify-between text-center">
          <div className="mt-8">
            <h2 className="text-white font-serif text-3xl font-bold tracking-wide uppercase leading-snug">
              How to Love<br />A Good Man
            </h2>
            <div className="w-12 h-0.5 bg-brand-accent mx-auto my-4" />
            <p className="text-white/80 text-xs tracking-widest uppercase">The 8 Essential Truths<br />of the Male Heart</p>
          </div>
          <p className="text-brand-accent tracking-widest uppercase text-sm mb-4">Andrei Ciomîrtan</p>
        </div>
      </div>
    </div>
  );
};

export default BookCover;